<template>
    <div id="concierge-services-page" class="margin-top-100">

        <!-- Content Section -->
        <section class="section-style">
            <div class="container padding-right-left-0">
                <div class="row">
                    <div class="col">
                        <h1 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">
                            Ultimate Travel Protection Insurance Offer
                        </h1>
                    </div>
                </div>

                <div class="row">
                    <div class="col" v-if="displayData.hasInsurance">
                        <p>
                            This booking already has an insurance, please contact your travel advisor for more
                            details.
                        </p>
                    </div>

                    <div class="col" v-if="requestSent">
                        <p>Thank you for requesting Ultimate Travel Protection! Contact your travel advisor for further details.</p>
                    </div>

                    <div class="col" v-if="!!!displayData.hasInsurance && !!!requestSent">
                        <div class="box-form bg-white box-shadow" v-if="form.reservation_id && !loading">
                            <div class="row" v-show="!showQuestions">
                                <p>Thank you, the current Insurance offerings are not available for travelers who are not residents of the United States. Please contact your dedicated travel advisor to learn about other Travel Insurance options.</p>
                            </div>
                            <div class="row" v-for="(question, index) in questions" v-show="showQuestions">
                                <div v-show="index === questionIndex">
                                    <span><strong>{{ question.text }}</strong></span>
                                    <div v-for="answer in question.answers" class="form-check">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="radio"
                                                   :value="answer.value"
                                                   :name="index"
                                                   v-model="responses[index]">
                                            {{ answer.text }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-2 row" v-show="showQuestions && !(questionIndex === questions.length)">
                                <button
                                    class="btn btn-secondary btn-sm mr-2"
                                    v-if="questionIndex > 0"
                                    @click="prev">
                                    Prev
                                </button>
                                <button class="btn btn-primary btn-sm" @click="next" :disabled="responses[questionIndex] === undefined">
                                    Next
                                </button>
                            </div>

                          <div :class="[!form.insurance_id ? 'text-center' : 'text-right']" v-show="questionIndex === questions.length" class="row">
                                <div class="col-12">
                                    <button
                                        v-if="silverPlanInsurance === null"
                                        type="button"
                                        v-for="(insurance, key) in ultimateTravelProtectionInsurances"
                                        v-show="insurance.name === 'UJV Silver Travel Protection Plan' || insurance.name === 'UJV Platinum Travel Protection Plan'"
                                        :key="insurance.id"
                                        class="btn btn-sm ml-2"
                                        :class="insurance.id === form.insurance_id ? 'btn-primary' : 'btn-secondary'"
                                        :disabled="loading"
                                        v-on:click="selectUltimateTravelProtectionInsurance(insurance)">
                                      {{ insurance.name }}
                                    </button>
                                    <button
                                        v-if="silverPlanInsurance"
                                        type="button"
                                        class="btn btn-sm ml-2 btn-primary"
                                        :disabled="loading">
                                        {{ this.silverPlanInsurance.name }}
                                    </button>
                                </div>
                                <div v-if="!form.insurance_id && !loading" class="col-12">
                                    <span class="text-danger">Select an Insurance Plan to calculate the Insurance Total</span>
                                </div>
                            </div>

                            <div v-if="form.insurance_id" class="row">
                                <div class="col-12 col-sm-6">
                                    <h4>Reservation Details</h4>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <h4 class="text-sm-right">
                                        Insurance Total:
                                        <span v-if="loading" class="spinner-border spinner-border-md margin-left-15 float-right" role="status" aria-hidden="true"></span>
                                        {{ displayData.insurance_amount }}
                                    </h4>
                                </div>
                            </div>

                            <div v-if="form.insurance_id" class="row">
                                <div class="col-12">
                                    <strong>Booking Number: </strong> <span>{{ displayData.booking_number }}</span>
                                </div>
                                <div class="col-12">
                                    <strong>Reservation Total: </strong>
                                    <span> {{ displayData.reservation_gross.toFixed(2) }}</span>
                                </div>
                            </div>

                            <div v-if="form.insurance_id" class="row margin-top-20">
                                <div class="col-12">
                                    <h4>Travelers Details</h4>
                                </div>
                            </div>

                            <form v-if="form.insurance_id" id="cfar-request-form" @submit.prevent="requestInsurance(form)">

                                <div class="row">
                                    <div class="col-6" v-for="(member, key) in form.members" :key="member.id">
                                        <div class="row">
                                            <div class="col-12 position-relative">
                                                <h5 class="text-center">Traveler #{{ key + 1 }}</h5>

                                                <popper trigger="clickToToggle"
                                                        :options="{
                                                    placement: 'top',
                                                    modifiers: {offset: {offset: '0,10px'} }
                                                    }">

                                                    <div class="popper">
                                                        <div class="list-group">
                                                            <div class="list-group-item"><strong>Copy From:</strong>
                                                            </div>
                                                            <a v-for="traveler in form.members"
                                                               v-if="traveler.id !== member.id"
                                                               class="list-group-item list-group-item-action"
                                                               href="javascript:void(0)"
                                                               :prevent-default="true"
                                                               @click="copyFrom(traveler, member, ...arguments)">
                                                                {{ traveler.first_name }} {{ traveler.last_name }}
                                                            </a>
                                                        </div>
                                                    </div>

                                                    <button type="button"
                                                            class="btn btn-sm btn-secondary"
                                                            slot="reference"
                                                            style="position:absolute; right:0; top:0">
                                                        <i class="fa fa-copy"></i>
                                                    </button>
                                                </popper>


                                            </div>
                                        </div>

                                        <div class="row" v-if="true">

                                            <!-- First Name -->
                                            <div class="col-12 col-md-4 form-group">
                                                <label class="font-sm">First Name</label>
                                                <i class="material-icons material-icons-sm">person_outline</i>
                                                <input name="agent_first_name" type="text"
                                                       class="form-control form-control-sm input-style input-style-sm input-style"
                                                       v-model="member.first_name"
                                                       aria-describedby="First Name">
                                                <p class="help text-danger margin-0"
                                                   v-if="$v.form.members.$each.$iter[key].first_name.$error">This field
                                                    is required</p>
                                            </div>

                                            <!-- Last Name -->
                                            <div class="col-12 col-md-4 form-group">
                                                <label class="font-sm">Last Name</label>
                                                <i class="material-icons material-icons-sm">person_outline</i>
                                                <input name="agent_last_name" type="text"
                                                       class="form-control form-control-sm input-style input-style-sm input-style"
                                                       v-model="member.last_name"
                                                       aria-describedby="First Name">
                                                <p class="help text-danger margin-0"
                                                   v-if="$v.form.members.$each.$iter[key].last_name.$error">This field
                                                    is required</p>
                                            </div>

                                            <!-- Date of Birth -->
                                            <div class="col-12 col-md-4 form-group">
                                                <label class="font-sm">Date of Birth</label>
                                                <i class="material-icons material-icons-sm">person_outline</i>
                                                <input name="date_of_birth" type="text"
                                                       class="form-control form-control-sm input-style input-style-sm input-style"
                                                       placeholder="MM/DD/YYYY"
                                                       v-model="member.date_of_birth"
                                                       aria-describedby="Date of Birth">
                                                <p class="help text-danger margin-0"
                                                   v-if="$v.form.members.$each.$iter[key].date_of_birth.$error">Please
                                                    input a date in the format MM/DD/YYYY</p>
                                            </div>
                                        </div>

                                        <div class="row">

                                            <!-- Address -->
                                            <div class="col-12 form-group">
                                                <label class="font-sm">Address</label>
                                                <i class="material-icons material-icons-sm">room</i>
                                                <input name="agent_address" type="text"
                                                       class="form-control form-control-sm input-style input-style-sm"
                                                       aria-describedby="Address"
                                                       v-model="member.address">
                                                <p class="help text-danger margin-0"
                                                   v-if="$v.form.members.$each.$iter[key].address.$error">This field is
                                                    required</p>
                                            </div>
                                        </div>

                                        <div class="row">

                                            <!-- Country -->
                                            <div class="col-12 col-md-6 form-group">
                                                <label class="font-sm">Country</label>
                                                <multiselect v-model="member.country"
                                                             @input="countryChanged(member, ...arguments)"
                                                             :options="location.countries"
                                                             label="name"
                                                             style="height:30px"
                                                             track-by="code"></multiselect>
                                                <p class="help text-danger margin-0"
                                                   v-if="$v.form.members.$each.$iter[key].country.$error">This field is
                                                    required</p>
                                            </div>

                                            <!-- State -->
                                            <div class="col-12 col-md-6 form-group">
                                                <label class="font-sm">State</label>

                                                <multiselect
                                                        v-if="member.country && (member.country === 'US' || member.country.code === 'US')"
                                                        v-model="member.state"
                                                        :options="location.usaStates"
                                                        label="name"
                                                        track-by="code">

                                                </multiselect>

                                                <multiselect
                                                        v-if="member.country && (member.country === 'CA' || member.country.code === 'CA')"
                                                        v-model="member.state"
                                                        :options="location.caStates"
                                                        label="name"
                                                        track-by="code">

                                                </multiselect>

                                                <input v-if="!member.country || (member.country.code !== 'CA' && member.country.code !== 'US')"
                                                       name="agent_state"
                                                       type="text"
                                                       class="form-control form-control-sm input-style input-style-sm input-style"
                                                       aria-describedby="State"
                                                       v-model="member.state">
                                                <p class="help text-danger margin-0"
                                                   v-if="$v.form.members.$each.$iter[key].state.$error">This field is
                                                    required</p>
                                            </div>
                                        </div>

                                        <div class="row">

                                            <!-- City -->
                                            <div class="col-12 col-md-6 form-group">
                                                <label class="font-sm">City</label>
                                                <i class="material-icons material-icons-sm">room</i>
                                                <input name="agent_city" type="text"
                                                       class="form-control form-control-sm input-style input-style-sm input-style"
                                                       aria-describedby="City"
                                                       v-model="member.city">
                                                <p class="help text-danger margin-0"
                                                   v-if="$v.form.members.$each.$iter[key].city.$error">This field is
                                                    required</p>
                                            </div>

                                            <!-- Zip -->
                                            <div class="col-12 col-md-6 form-group">
                                                <label class="font-sm">Zip</label>
                                                <i class="material-icons material-icons-sm">room</i>
                                                <input name="agent_zip" type="text"
                                                       class="form-control form-control-sm input-style input-style-sm input-style"
                                                       aria-describedby="Zip code"
                                                       v-model="member.zip">
                                                <p class="help text-danger margin-0"
                                                   v-if="$v.form.members.$each.$iter[key].zip.$error">This field is
                                                    required</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="row">
                                    <div class="col-12" v-if="displayData.per_person && form.members.length === 0">
                                        <span class="text-danger">Insurance selected is calculated per travelers, and there are no travelers in the reservation. Please contact your travel advisor.</span>
                                    </div>
                                    <div class="col-12">
                                        <button class="btn btn-primary bt-lg" :disabled="loading || !form.insurance_id || (displayData.per_person && form.members.length === 0)">
                                            <span v-if="loading" class="spinner-border spinner-border-sm" role="status"
                                                  aria-hidden="true"></span>
                                            Request Insurance
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="!!!form.reservation_id && loading">
                    <div class="col-12 text-center">
                        <span
                            v-if="loading"
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                        ></span>
                    </div>
                </div>

            </div>
        </section>

    </div>
</template>

<script>
    import {validationMixin} from "vuelidate";
    import {required} from 'vuelidate/lib/validators'
    import {HttpResponseStatus} from "../services/Http/HttpResponse";
    import Multiselect from "vue-multiselect";
    import {get, isEmpty} from "lodash";
    import {caStates, countries, usaStates} from "../services/locationData";
    import Vue from "vue";

    import Popper from 'vue-popperjs';
    import 'vue-popperjs/dist/vue-popper.css';

    export default {
        mixins: [validationMixin],
        components: {Multiselect, 'popper': Popper},
        created() {

        },
        mounted() {
            this.getReservation();
        },
        data: function () {
            return {
                loading: false,
                reservation: null,
                showQuestions: true,
                questions: [
                    {
                        text: 'Are the travelers residents of the United States?',
                        answers: [
                            {text: 'Yes', value: 'yes'},
                            {text: 'No', value: 'no'},
                        ],
                    },
                    {
                        text: 'Are the travelers residents of the State of New York?',
                        answers: [
                            {text: 'Yes', value: 'yes'},
                            {text: 'No', value: 'no'},
                        ],
                    },
                ],
                questionIndex: 0,
                responses: [],
                displayData: {
                    booking_number: null,
                    insurance_amount: 0,
                    policy_url: null,
                    reservation_gross: null,
                    per_person: false
                },
                form: {
                    insurance_id: null,
                    reservation_id: null,
                    members: []
                },
                location: {
                    countries,
                    usaStates,
                    caStates
                },
                requestSent: false,
                ultimateTravelProtectionInsurances: [],
                silverPlanInsurance: null,
            };
        },
        methods: {
            prev() {
                this.questionIndex--;
            },
            next: function() {
                if (this.responses[this.questionIndex] !== undefined) {

                    if (this.questionIndex === 0 && this.responses[this.questionIndex] === 'no')
                    {
                        this.showQuestions = false;
                    }

                    if (this.questionIndex === this.questions.length - 1 && this.responses[1] === 'yes')
                    {
                        this.silverPlanInsurance = !isEmpty(this.ultimateTravelProtectionInsurances.filter(insurance => insurance.name === 'UJV Silver Travel Protection Plan'))
                            ? this.ultimateTravelProtectionInsurances.filter(insurance => insurance.name === 'UJV Silver Travel Protection Plan')[0]
                            : null;

                        if (this.silverPlanInsurance !== null)
                        {
                            this.selectUltimateTravelProtectionInsurance(this.silverPlanInsurance);
                        }
                    }
                    this.questionIndex++;
                }
            },
            copyFrom(source, destination) {
                destination.address = source.address;
                destination.country = source.country;
                destination.state = source.state;
                destination.city = source.city;
                destination.zip = source.zip;
            },
            countryChanged(member, value) {
                member.state = '';
            },
            async getReservation() {
                this.loading = true;

                const response = await this.$httpClient.request('GET', `api/reservations/get-by-id/${this.$route.params.reservationId}`, null);

                if (response.status !== HttpResponseStatus.OK)
                {
                    this.loading = false;
                    return;
                }

                this.displayData.hasInsurance = !isEmpty(get(response.data, 'reservationInsurances'));

                if (this.displayData.hasInsurance)
                {
                    this.loading = false;
                    return;
                }

                await this.getUltimateTravelProtectionInsurances(response.data.id);
                this.loading = false;

                this.form = {
                    ...this.form,
                    reservation_id: response.data.id,
                    members: response.data.reservationTravelingMembers.map((m) => {
                        const data = _.pick(m, [
                            'id',
                            'first_name',
                            'last_name',
                            'date_of_birth',
                            'country',
                            'state',
                            'city',
                            'address',
                            'zip'
                        ]);

                        const country = data.country;
                        data.date_of_birth = data.date_of_birth ? data.date_of_birth : '';
                        data.country = _.find(this.location.countries, {code: country});

                        if (data.country)
                            data.state = _.find(country === 'US' ? this.location.usaStates : this.location.caStates, {code: data.state});
                        else
                            data.state = '';

                        return data;
                    }),
                };

                this.displayData.reservation_gross = response.data.numbers.gross;
                this.displayData.booking_number = response.data.booking_number;
            },

            async getUltimateTravelProtectionInsurances(reservation_id) {
                this.loading = true;

                const response = await this.$httpClient.request('GET', `api/reservations/get-ultimate-travel-protection-insurances/${reservation_id}`, null);

                if (response.status === HttpResponseStatus.OK) {
                  this.ultimateTravelProtectionInsurances = response.data.insurances;
                }

                this.loading = false;
            },

            selectUltimateTravelProtectionInsurance(insurance) {
                this.displayData.insurance_amount = 0;
                this.displayData.per_person = insurance.per_person;

                // Set amount and url only if there is travelers in the reservation
                if(!this.displayData.per_person || this.form.members.length > 0){
                    this.displayData.insurance_amount = insurance.total_rack;
                    this.displayData.policy_url = insurance.policy_url;
                }

                this.form.insurance_id = insurance.id;
            },

            async requestInsurance(form) {
                this.$v.$touch();

                if (this.$v.$invalid)
                    return;

                this.loading = true;

                const data = {
                    ...form,
                    members: form.members.map((member) => {
                        const result = {...member};

                        if (result.country instanceof Object)
                            result.country = result.country.code;

                        if (result.state instanceof Object)
                            result.state = result.state.code;

                        return result;
                    })
                };

                const response = await this.$httpClient.request('POST', 'api/actions/request-ultimate-travel-protection-insurance', data);

                this.loading = false;

                if (response.status !== HttpResponseStatus.OK)
                    return;

                this.requestSent = true;
            }

        },
        validations: {
            form: {
                reservation_id: {required},
                members: {
                    $each: {
                        first_name: {required},
                        last_name: {required},
                        address: {required},
                        date_of_birth: {
                            date_format: (value) => {
                                if (!value) return false;

                                return Vue.moment(value, "MM/DD/YYYY", true).isValid();
                            }
                        },
                        city: {required},
                        state: {required},
                        zip: {required},
                        country: {required},
                    }
                }

            }
        },
    }
</script>

<style lang="scss">
    .multiselect__tags, .multiselect, .multiselect__select {
        max-height: 33px !important;
        min-height: 33px !important;
    }

    div.multiselect__tags {
        padding-top: 4px;
        font-size: 0.875rem;
    }

    .btn-sm {
        padding: 0.25rem 0.5rem !important;
    }
</style>
